import React, { useRef } from 'react'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import CircularProgress from '@mui/material/CircularProgress'
import { Traduccion } from './Traduccion'
import { Messages } from './Messages2'
import { Acciones } from '../utils/Constantes'

export const AutocompleteComp = ({ id, onSelect, clearOnSelect, autoFocus, seleccion, label, itemLabel, serviceCall, editable = true, requerido, validarSubmit }) => {
    const [open, setOpen] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [inputValue, setInputValue] = React.useState(itemLabel(seleccion))
    const timeoutRef = useRef(null)
    const [resServicio, setResServicio] = React.useState({data:[]})

    const _handleSelect = (event, val) => {
        if (!val?.id) return
        setOpen(false)
        onSelect(val, id)
        if (clearOnSelect) {
            setInputValue('')
        }
    }

    const _handleInputChange = async (event, val, reason) => {
        setInputValue(val)
        if (reason === 'clear') 
            return onSelect(null, id) && setOpen(false)
        if (timeoutRef.current !== null) {          // IF THERE'S A RUNNING TIMEOUT
            clearTimeout(timeoutRef.current)       // THEN, CANCEL IT
        }
        if (val.length > 2 && event && event.type !== 'click' && event.key !== 'Enter') {
            timeoutRef.current = setTimeout(async () => {
                timeoutRef.current = null          // RESET REF TO NULL WHEN IT RUNS
                setLoading(true)
                const response = await serviceCall(val)
                setResServicio(response)
                setOpen(true)
                setLoading(false)
            }, 750)
        }
    }

    const _getOptionLabel = (option) => option.id ? itemLabel(option) : option

    React.useEffect(() => {
        setInputValue(itemLabel(seleccion))
    }, [seleccion, itemLabel])

    return <>
        <Autocomplete id={id}
            clearText={Traduccion('TXT_BORRAR')}
            open={open}
            options={resServicio.data}
            getOptionLabel={_getOptionLabel}
            value={seleccion}
            onChange={_handleSelect}
            inputValue={inputValue}
            onInputChange={_handleInputChange}
            disabled={!editable}
            freeSolo
            renderInput={(params) => (
                <TextField label={Traduccion(label)}
                    variant="outlined"
                    margin="dense"
                    autoFocus={autoFocus}
                    required={requerido}
                    helperText={validarSubmit && requerido && !seleccion ? Traduccion('TXT_REQUERIDO') : ''}
                    error={validarSubmit && requerido && !seleccion}
                    {...params}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading && <CircularProgress color="inherit" size={20} />}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        )
                    }} />
            )}
        />
        <Messages resServicio={resServicio.errores ? resServicio : undefined} accion={Acciones.SEE} />
    </>
}